module.exports = __webpack_public_path__ + "static/img/speed-up.90a1d394.png";